import type { PartnersContent } from "../types";

export const partners: PartnersContent = {
  title: "Infrastructure partners",
  lead:
    "UCloud AI runs on national sovereign infrastructure: sustainable " +
    "datacenters built in collaboration with Danfoss and HPE, with the " +
    "option to scale to the Gefion AI supercomputer.",
  gridAriaLabel: "Infrastructure partners and collaborators",
  partnerNames: {
    deic: "DeiC",
    danfoss: "Danfoss",
    hpe: "HPE",
    dcai: "DCAI",
    dfm: "Danish Foundation Models",
  },
  partnerRoles: {
    deic: "National e-infrastructure",
    danfoss: "Sustainable technology",
    hpe: "Enterprise technology / HPC",
    dcai: "Gefion AI supercomputer",
    dfm: "Danish open models",
  },
  partnerHrefs: {
    deic: "https://deic.dk/en",
    danfoss: "https://www.danfoss.com/en/",
    hpe: "https://www.hpe.com/",
    dcai: "https://www.dcai.dk/",
    dfm: "https://www.foundationmodels.dk/",
  },
};
